import React from 'react';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

// const directionTransform = {
//     left: null,
//     right: 'scale(-1, 1)',
//     top: 'rotate(180) translate(0, -30)',
//     bottom: 'rotate(180) translate(0, 30)',
// };

const propTypes = {
    direction: AppPropTypes.arrowDirection,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    direction: 'left',
    color: 'currentColor',
    className: null,
};

const EmployeeArrow = ({ direction, color, className }) => (
    <svg
        id="b"
        xmlns="http://www.w3.org/2000/svg"
        style={direction === 'right' ? { transform: 'scale(-1, 1)' } : null}
        viewBox="0 0 103.13 40.36"
        className={className}
    >
        <g>
            <g>
                <polyline
                    points="11.6 34.05 5.99 39.66 5.96 39.63 .35 34.02"
                    fill="none"
                    stroke={color}
                    strokeMiterlimit="10"
                />
                <polyline
                    points="103.13 .5 5.99 .5 5.99 33.75"
                    fill="none"
                    stroke={color}
                    strokeMiterlimit="10"
                />
            </g>
        </g>
    </svg>
);

EmployeeArrow.propTypes = propTypes;
EmployeeArrow.defaultProps = defaultProps;

export default EmployeeArrow;
